const normalizeLugarName = (value) =>
  String(value || "")
    .trim()
    .toLocaleLowerCase("es-MX");

const specialLugarRank = (lugar) => {
  const name = normalizeLugarName(lugar?.nombre ?? lugar?.label);
  if (name === "club arawaks") return 0;
  if (name === "otro") return 2;
  return 1;
};

export function sortLugaresForDisplay(lugares = []) {
  return [...lugares].sort((a, b) => {
    const rankDiff = specialLugarRank(a) - specialLugarRank(b);
    if (rankDiff !== 0) return rankDiff;
    return normalizeLugarName(a?.nombre ?? a?.label).localeCompare(
      normalizeLugarName(b?.nombre ?? b?.label),
      "es-MX"
    );
  });
}
